export const counterPatternFeatureTranslationJP = {
  CounterPatternSettingPage: {
    head_title: 'レジパターン別表示設定',
    menu_classification: 'メニュー分類',
    menu_type: 'サブメニュー属性',
    menu_name: 'メニュー名',
    menu_code: 'メニューコード',
    menu_code_description: '※メニューコード+区分<br/>(通常:U、食べ放題:T、<br/>クーポン:C）',
    related_pos: '関連するレジ情報',
    related_pos_guide: '※関連するレジ情報からメニューを抽出します。',
    target_date: '有効期限',
    start_date: '開始日',
    end_date: '終了日',
    pos_code: 'POSコード',
    pos_name: 'POS名',
    search: '絞り込み',
    export_csv: '絞り込んでCSV出力',
    pos_info: 'レジ情報',
    display_counter_pattern: 'レジパターン別表示有無',
    setting_store_search: '個別設定店舗検索',
    setting_store: '個別設定店舗',
    setting_guide: '※店舗個別設定あり。「個別設定店舗検索」からご確認ください。',
    individual_setting: '個別設定有無',
  },
  CounterPatternMobileOrderDisplayModal: {
    head_title: 'パターン個別設定',
    menu_information: '〇メニュー情報',
    counter_pattern: 'レジパターン',
    menu: 'メニュー',
    save: '保存',
  },
  CounterPatternStoreMobileOrderDisplayModal: {
    head_title: '個別設定店舗検索',
    menu: 'メニュー',
    setting_mo_guide: '※店舗個別設定あり。',
    store_code: '店舗コード',
    store_name: '店舗名',
    display: '表示',
    counter_pattern: 'レジパターン',
    action_mo: '有効／無効',
  },
};
